var _path, _path2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8TongaCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M44,24c0,11.046-8.954,20-20,20S4,35.046,4,24c0.372-2.319,2.036-4.667,2.702-6.66 C7.987,13.493,14.489,11,14.489,11s1.092-4.019,2.559-4.66c2.451-1.072,4.149-1.83,6.995-1.83c0.923,0,1.788-0.367,2.678-0.246 c0.08,0.011,0.161-0.058,0.24-0.047C36.603,5.648,44,13.96,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M4,24h22.995V4.216C25.988,4.088,24.967,4.026,23.932,4C12.887,4.228,4,13.086,4,24z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d50000",
    points: "23.5,13.413 19.087,13.413 19.087,9 14.913,9 14.913,13.413 10.5,13.413 10.5,17.587 14.913,17.587 14.913,22 19.087,22 19.087,17.587 23.5,17.587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8TongaCircular);
export default __webpack_public_path__ + "static/media/icons8-tonga-circular.02bb2367b34bdf20c4436b91596b025c.svg";
export { ForwardRef as ReactComponent };